var map = {
	"./pretty-bear.jpg": "f4ae",
	"./pretty-boat.jpg": "9ed33",
	"./pretty-sky.png": "6cb5",
	"./pretty-waves.jpg": "ace8",
	"./pretty-waves.png": "bd75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "031a";